module.exports = __webpack_public_path__ + "static/img/goods-2.abff8ab8.png";